"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mount(target, Component, props) {
    const oldEl = target.previousElementSibling;
    if (oldEl === null) {
        return;
    }
    oldEl.style.display = "none";
    return new Component({
        target,
        props: {
            params: props,
            oldInput: oldEl,
        }
    });
}
exports.mount = mount;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJtb3VudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLFNBQWdCLEtBQUssQ0FBQyxNQUFtQixFQUFFLFNBQWMsRUFBRSxLQUFVO0lBQ25FLE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxzQkFBMEMsQ0FBQztJQUNoRSxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDbEIsT0FBTztLQUNSO0lBQ0QsS0FBSyxDQUFDLEtBQUssQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDO0lBQzdCLE9BQU8sSUFBSSxTQUFTLENBQUM7UUFDbkIsTUFBTTtRQUNOLEtBQUssRUFBRTtZQUNMLE1BQU0sRUFBRSxLQUFLO1lBQ2IsUUFBUSxFQUFFLEtBQUs7U0FDaEI7S0FDRixDQUFDLENBQUM7QUFDTCxDQUFDO0FBYkQsc0JBYUMiLCJzb3VyY2VzQ29udGVudCI6WyJcbmV4cG9ydCBmdW5jdGlvbiBtb3VudCh0YXJnZXQ6IEhUTUxFbGVtZW50LCBDb21wb25lbnQ6IGFueSwgcHJvcHM6IGFueSkge1xuICBjb25zdCBvbGRFbCA9IHRhcmdldC5wcmV2aW91c0VsZW1lbnRTaWJsaW5nIGFzIEhUTUxJbnB1dEVsZW1lbnQ7XG4gIGlmIChvbGRFbCA9PT0gbnVsbCkge1xuICAgIHJldHVybjtcbiAgfVxuICBvbGRFbC5zdHlsZS5kaXNwbGF5ID0gXCJub25lXCI7XG4gIHJldHVybiBuZXcgQ29tcG9uZW50KHtcbiAgICB0YXJnZXQsXG4gICAgcHJvcHM6IHtcbiAgICAgIHBhcmFtczogcHJvcHMsXG4gICAgICBvbGRJbnB1dDogb2xkRWwsXG4gICAgfVxuICB9KTtcbn0iXX0=